export default ({ hasMore, loadMore }) => ({
    lastScrollTop: 0,
    loadingMore: false,
    container: null,
    hasMore,

    init() {
        this.$nextTick(() => {
            this.container = this.$el;
            const containerItems = this.container.querySelectorAll('[id^="notification-item-"]');
            const sumHeight = Array.from(containerItems).reduce((sum, item) => sum + item.scrollHeight, 0);

            if (!containerItems.length) return;

            if (sumHeight <= this.container.scrollHeight - 30) {
                loadMore();
            }

            this.container.addEventListener('scroll', () => {
                if (this.scrollRaf) cancelAnimationFrame(this.scrollRaf);
                this.scrollRaf = requestAnimationFrame(() => this.handleScroll());
            });
        });
    },

    async handleScroll() {
        if (this.loadingMore) return;

        const goingDown = this.container.scrollTop > this.lastScrollTop;
        this.lastScrollTop = this.container.scrollTop;

        if (
            goingDown &&
            this.hasMore &&
            this.container.scrollTop + this.container.clientHeight >= this.container.scrollHeight - 20
        ) {
            try {
                this.loadingMore = true;
                await loadMore();
            } finally {
                this.loadingMore = false;
            }
        }
    },
});
